import {
  index,
  integer,
  primaryKey,
  sqliteTable,
  text
} from 'drizzle-orm/sqlite-core';

// One row per record deleted from a synced table, so the delete reaches the
// other device instead of the row coming back from it (.specs/device-sync.md).
//
// The key is (table_name, record_id): that pair is what a tombstone is looked
// up by, and deleting the same record twice must update one row, not add a
// second. No `id`/`updated_at` of its own — tombstones are exchanged as a set,
// never as rows of the row sync.
export const syncTombstones = sqliteTable(
  'sync_tombstones',
  {
    tableName: text('table_name').notNull(),
    recordId: text('record_id').notNull(),
    deletedAt: integer('deleted_at').notNull(), // Unix timestamp (ms)
    // The record whose delete removed this one: the record itself for a direct
    // delete, the post for a row that went with its post. A delete is undone
    // as a whole, so every tombstone names the delete it belongs to.
    rootTableName: text('root_table_name').notNull(),
    rootRecordId: text('root_record_id').notNull()
  },
  (t) => [
    primaryKey({ columns: [t.tableName, t.recordId] }),
    index('idx_sync_tombstones_root').on(t.rootTableName, t.rootRecordId),
    index('idx_sync_tombstones_deleted_at').on(t.deletedAt)
  ]
);
